export default "__VITE_ASSET__BmZIdaYr__"